.LoadingOverlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-index-modal-overlay);
  display: flex;
  align-items: center;
  justify-content: center;

  /* light dashboard surface with a soft mint halo behind the mark */
  background:
    radial-gradient(
      circle at center,
      var(--rv-accent-glow-12),
      transparent 55%
    ),
    var(--rv-bg-app);
  backdrop-filter: var(--rv-blur-md);
}

.Stage {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3xl);
}

/* Entrance plays once per page load (first mount), not on the gate hand-off
   remounts — replaying it on every remount is what made the splash flash. */
.StageIn {
  animation: revvly-stage-in var(--rv-dur-slow) var(--rv-ease-out) both;
}

/* enlarge the mark for the full-page splash (two classes beat the inline default) */
.LoadingOverlay .Stage svg {
  width: var(--space-7xl);
  height: var(--space-7xl);
  filter: drop-shadow(0 0 20px var(--rv-accent-glow-20));
}

.Message {
  margin: 0;
  min-height: var(--space-3xl);
  font-family: var(--font-family-display);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
  color: var(--content-foundation-content-secondary);
  text-align: center;
}

/* Applied only when the message actually rotates, so a remounted overlay shows
   its (persisted) line immediately instead of re-fading it in. */
.MessageIn {
  animation: revvly-message-in var(--rv-dur-slow) var(--rv-ease-out) both;
}

@keyframes revvly-stage-in {
  from {
    opacity: 0%;
    transform: translateY(8px);
  }

  to {
    opacity: 100%;
    transform: translateY(0);
  }
}

@keyframes revvly-message-in {
  from {
    opacity: 0%;
    transform: translateY(4px);
  }

  to {
    opacity: 100%;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .StageIn,
  .MessageIn {
    animation: none;
  }
}
